import template from './CheatSheetSampleDialog.html';

class CheatSheetSampleDialogVM
{
	constructor(dialog)
	{
		this.dialog = dialog;
	}
	
	close() {
		this.dialog.close();
	}
	
	confirm() {
		this.dialog.close();
	}
}

class CheatSheetSampleDialog
{
	constructor(bindings, element)
	{
		this.bindings = bindings || {};
		this.viewModel = new CheatSheetSampleDialogVM(this);
	}
}

export default {
	name: 'CheatSheetSampleDialog',
	dialog_class: CheatSheetSampleDialog,
	provider: 'ps',
	template: template
}

